import React, { useState, useEffect } from 'react';
import '../../App.css';
import { Link, useNavigate } from 'react-router-dom'; // Import Link and useNavigate components
import { fetchDashboardData } from '../../services/api'; // Import your function
import { SideMenu, Header,TopMenu } from 'maxcu-shared-lib';
import menuItems from '../SideMenu/menuItems';

// Add styles for mobile responsiveness
const styles = {
  headerContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    backgroundColor: 'white',
    padding: '0',
    margin: '0',
    
  },
  mainContent: {
    marginTop: '120px', // Increased to account for header height
    padding: '0px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  trackerBox: {
    backgroundColor: '#bfeaf2',
    padding: '13px',
    borderRadius: '6px',
    marginBottom: '8px'
  },
  piggyContainer: {
    width: '35%',
    height: 'auto',
    display: 'block',
    marginTop: '-30px',
    marginBottom: '20px'
  },
  newGoalButton: {
    padding: '10px 20px',
    fontSize: '1.2rem',
    backgroundColor: '#1e3a8a',
    color: 'white',
    border: 'blue',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '0px',
    marginBottom: '10px'
  }
};



function App() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    document.title = 'Round Up | MAX Credit Union';
  }, []);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    async function fetchData() {
        try {
            const jsonData = await fetchDashboardData();
            setData(jsonData);
        } catch (error) {
            setError(error.message);
        }
    }
    fetchData();
  }, []);

  if (error) return <div>Error: {error}</div>;
  if (!data) return <div>Loading...</div>;

  const operation = data.OPERATION && data.OPERATION[0];

  if (operation.TRACKING === 'NO') {
    navigate('/Register'); // Navigate to Register
    return <div>No operation data available</div>;
  }

  return (
    <div>
      <div style={styles.headerContainer}>
        <Header name='Round Up' />
        <SideMenu menuItems={menuItems} />
        {isMobile && <TopMenu />}
      </div>
      <div style={styles.mainContent}>
        {!isMobile && (
          <div className="centered">
            <img 
              src="/Savings01.png" 
              alt="Piggie" 
              className="piggy-image"
              style={styles.piggyContainer}
            />
          </div>
        )}
        <div className="tracker-box" style={styles.trackerBox}>
          <h2 className="text-blue text-10xl" style={{ fontSize: '1.2rem', margin: '0', padding: '0' }}>Round Up Savings Tracker</h2>
        </div>
        <div className="column-container">
          <div className="column">
            <div className="tracker-box" style={styles.trackerBox}>
              <p className="text-blue text-sm">I'm Saving For</p>
              <h2 className="text-blue text-3xl">{operation.GOALNAME}</h2>
            </div>
            <div className="tracker-box" style={styles.trackerBox}>
              <p className="text-blue text-sm">Goal Amount</p>
              <h2 className="text-blue text-3xl">${operation.GOALAMOUNT}</h2>
            </div>
            <div className="tracker-box" style={styles.trackerBox}>
              <p className="text-blue-900 text-sm">Total Saved For My Goal</p>
              <h2 className="text-blue-900 text-3xl">${operation.TOTALSAVED}</h2>
            </div>
          </div>
          <div className="column">
            <div className="tracker-box" style={styles.trackerBox}>
              <p className="text-blue text-sm">Saved this Month</p>
              <h2 className="text-blue text-3xl">${operation.MONTHSAVED}</h2>
            </div>
            <div className="tracker-box" style={styles.trackerBox}>
              <p className="text-blue-900 text-sm">Lifetime Saved</p>
              <h2 className="text-blue-900 text-3xl">${operation.LIFETIME}</h2>
            </div>
            <div className="tracker-box" style={styles.trackerBox}>
              <p className="text-blue-900 text-sm">Saving Style</p>
              <h2 className="text-blue-900 text-3xl" style={{ textTransform: 'none' }}>{operation.SAVETYPE}</h2>
            </div>
          </div>
        </div>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <Link to="/Register">
            <button style={styles.newGoalButton}>
              New Goal
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default App;
